import { useState } from "react";
import {
  getWatchlistVisibility,
  saveWatchlistVisibility,
  isWatchlistSupported,
  getWatchlistWidth,
  saveWatchlistWidth,
} from "../utility/helperFunc";
import { WATCHLIST_CONTAINER_WIDTH } from "../utility/mp_chart_constants";

export function useWatchlist(chartId) {
  const [watchListVisible, setWatchListVisible] = useState(
    () => getWatchlistVisibility(chartId)
  );
  const [watchListWidth, setWatchListWidth] = useState(() => {
    const visible = getWatchlistVisibility(chartId);
    return visible ? getWatchlistWidth(WATCHLIST_CONTAINER_WIDTH) : 0;
  });

  const openWatchlist = () => {
    const width = getWatchlistWidth(WATCHLIST_CONTAINER_WIDTH);
    setWatchListVisible(true);
    setWatchListWidth(width);
    saveWatchlistVisibility(chartId, true);
  };

  const closeWatchlist = () => {
    setWatchListVisible(false);
    setWatchListWidth(0);
    saveWatchlistVisibility(chartId, false);
  };

  const updateWatchlistWidth = (width) => {
    setWatchListWidth(width);
    saveWatchlistWidth(width);
  };

  const toggleWatchlist = (chartScreenType, onUnsupported) => {
    if (watchListVisible) {
      closeWatchlist();
    } else if (isWatchlistSupported(chartScreenType)) {
      openWatchlist();
    } else {
      onUnsupported?.();
    }
  };

  return {
    watchListVisible,
    watchListWidth,
    openWatchlist,
    closeWatchlist,
    toggleWatchlist,
    updateWatchlistWidth,
  };
}